import { Icon, Tooltip, Typography } from 'shared/ui'
import { LINK_AUTO_REMINDERS_LEARN_MORE } from 'shared/constants/links'
import { WidgetItem } from 'pages/chatbot/ui/UnifiedAgent/ui/Chat/ui/Widgets'
import { FOLLOW_UP_ASSERTIVENESS_OPTIONS } from 'pages/chatbot/ui/UnifiedAgent/ui/AutoFollowUpSection/store/autoFollowUpWidgetStore'
import styles from './styles.module.scss'

type IAutoFollowUpStep3Props = {
  focusedIndex: number
  onSelect: (index: number) => void
}

export const AutoFollowUpStep3 = ({ focusedIndex, onSelect }: IAutoFollowUpStep3Props) => (
  <div className={styles.list}>
    {FOLLOW_UP_ASSERTIVENESS_OPTIONS.map((item, index) => (
      <WidgetItem
        key={item.id}
        isFocused={index === focusedIndex}
        badgeIndex={index}
        onClick={() => onSelect(index)}
        rightNode={
          <div className={styles.assertivenessRightNode}>
            <Typography
              variant={'body-rg-regular'}
              ariaLabel={item.rightLabel}
              color={'var(--content-primary-tertiary)'}
            >
              {item.rightLabel}
            </Typography>
            <Tooltip
              label={
                <>
                  The agent follows up within the set window. <br />
                  <a href={LINK_AUTO_REMINDERS_LEARN_MORE} target='_blank' rel='noreferrer'>
                    Learn more
                  </a>
                </>
              }
              placement='top'
              ariaLabel={item.label}
              breakWord
            >
              <Icon icon={'question'} color={'var(--content-neutral-primary)'} />
            </Tooltip>
          </div>
        }
      >
        <Typography variant={'body-rg-regular'} ariaLabel={item.label}>
          {item.label}
        </Typography>
      </WidgetItem>
    ))}
  </div>
)
